import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { dismissBoot } from '../core';

/**
 * 실제 화면을 여는 자리 — 여기가 처음 그려질 때 부팅 대기 화면을 흐리게 걷는다(`dismissBoot`).
 *
 * 게이트 밖 화면(설정·링크·디버그)은 레이아웃 라우트로, 게이트 안은 복원이 끝나 열릴 때
 * `RequireProfile` 이 이것을 그린다. 복원을 기다리는 동안은 여기를 거치지 않으므로 대기 화면이 남는다.
 */
export const BootDismissOutlet = () => {
  useEffect(() => {
    dismissBoot();
  }, []);

  return <Outlet />;
};
